import { render, staticRenderFns } from "./class-report-form.vue?vue&type=template&id=e957e04a&scoped=true&"
import script from "./class-report-form.vue?vue&type=script&lang=js&"
export * from "./class-report-form.vue?vue&type=script&lang=js&"
import style0 from "./class-report-form.vue?vue&type=style&index=0&id=e957e04a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e957e04a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRating } from 'vuetify/lib/components/VRating';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VChip,VDivider,VRating,VTextField})
